import "./src/styles/global.scss";

/**
 * Re-execute scripts inserted via dangerouslySetInnerHTML (embed blocks).
 *
 * React's dangerouslySetInnerHTML inserts HTML but the browser does NOT
 * execute <script> tags it creates this way — neither inline scripts nor
 * external src scripts. This breaks self-contained embeds (calculators,
 * widgets, third-party snippets) that rely on their own JS.
 *
 * Fix: scan for script tags inside embed containers and replace each one
 * with a freshly-created <script> element. Cloning via createElement forces
 * the browser to execute it.
 *
 * Runs on:
 *   - onInitialClientRender  (fresh page load / reload)
 *   - onRouteUpdate          (client-side navigation between pages)
 */

function reexecuteEmbedScripts() {
  if (typeof window === "undefined" || typeof document === "undefined") return;

  try {
    // Cast a wide net for embed script tags. We mark executed scripts so
    // we don't re-run them on subsequent passes.
    const scripts = document.querySelectorAll("script:not([data-reinit-done])");
    scripts.forEach((oldScript) => {
      // Only target scripts that live inside something that looks like an embed
      // container — avoids re-running Gatsby, GTM, or analytics scripts in <head>.
      const inEmbed =
        oldScript.closest(
          '.calc-compound, .calc-amort, .calc-mort, .calc-sg, .calc-debt, .calc-fire, .calc-coast, .calc-b503020, .rel-calcs, [class*="-calculator"]'
        ) || oldScript.closest("article") || oldScript.closest(".article-body");
      if (!inEmbed) return;
      // Skip application/ld+json and similar non-JS types
      const type = (oldScript.getAttribute("type") || "").toLowerCase();
      if (type && type !== "text/javascript" && type !== "application/javascript" && type !== "module") return;

      const newScript = document.createElement("script");
      Array.from(oldScript.attributes).forEach((attr) => {
        newScript.setAttribute(attr.name, attr.value);
      });
      newScript.setAttribute("data-reinit-done", "true");
      if (oldScript.src) {
        newScript.src = oldScript.src;
      } else {
        newScript.textContent = oldScript.textContent;
      }
      oldScript.parentNode.replaceChild(newScript, oldScript);
    });
  } catch (e) {
    /* noop */
  }

  // Re-init third-party embed libraries whose HTML was (re)inserted.
  try {
    if (window.twttr && window.twttr.widgets && typeof window.twttr.widgets.load === "function") {
      window.twttr.widgets.load();
    }
  } catch (e) { /* noop */ }
  try {
    if (window.instgrm && window.instgrm.Embeds && typeof window.instgrm.Embeds.process === "function") {
      window.instgrm.Embeds.process();
    }
  } catch (e) { /* noop */ }
  try {
    if (window.tiktok && typeof window.tiktok.reload === "function") {
      window.tiktok.reload();
    }
  } catch (e) { /* noop */ }
}

export const onInitialClientRender = () => {
  // Wait a tick so React has fully hydrated the embed HTML into the DOM.
  setTimeout(reexecuteEmbedScripts, 100);
};

export const onRouteUpdate = () => {
  // Wait for the new page's embed HTML to be painted before scanning.
  setTimeout(reexecuteEmbedScripts, 100);
};

// export const wrapRootElement = ({ element }) => {
//   useEffect(() => {
//     const script = document.createElement("script");
//     script.src = "https://cdn.convertbox.com/convertbox/js/embed.js"; // Your ConvertBox script URL
//     script.async = true;
//     script.id = "app-convertbox-script";
//     script.dataset.uuid = "a1ce5f9e-d630-4668-be5b-3554f61e94a7";
//     document.head.appendChild(script);

//     return () => {
//       // Clean up if needed (optional)
//       document.head.removeChild(script);
//     };
//   }, []);

//   return element;
// };

// export const onRouteUpdate = ({ location, prevLocation }) => {
//   <>
//     <Script
//       strategy="idle"
//       dangerouslySetInnerHTML={{
//         _html: `function SendUrlToDeadlineFunnel(e){var r,t,c,a,h,n,o,A,i = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",d=0,l=0,s="",u=[];if(!e)return e;do r=e.charCodeAt(d++),t=e.charCodeAt(d++),c=e.charCodeAt(d++),A=r<<16|t<<8|c,a=A>>18&63,h=A>>12&63,n=A>>6&63,o=63&A,u[l++]=i.charAt(a)+i.charAt(h)+i.charAt(n)+i.charAt(o);while(d<e.length);s=u.join("");var C=e.length%3;var decoded = (C?s.slice(0,C-3):s)+"===".slice(C||3);decoded = decoded.replace("+", "-");decoded = decoded.replace("/", "_");return decoded;} var dfUrl = SendUrlToDeadlineFunnel(location.href); var dfParentUrlValue;try {dfParentUrlValue = window.parent.location.href;} catch(err) {if(err.name === "SecurityError") {dfParentUrlValue = document.referrer;}}var dfParentUrl = (parent !== window) ? ("/" + SendUrlToDeadlineFunnel(dfParentUrlValue)) : "";(function() {var s = document.createElement("script");s.type = "text/javascript";s.async = true;s.setAttribute("data-scriptid", "dfunifiedcode");s.src ="https://a.deadlinefunnel.com/unified/reactunified.bundle.js?userIdHash=eyJpdiI6IjdvQ2hya2w0YkMwUkdIZnpJSU5JWGc9PSIsInZhbHVlIjoiZ3hxZjgyeTBNMWFcL2V5OUpPa2FhdWc9PSIsIm1hYyI6ImEyN2RlODNlZGIzYTRkNzYzMTlhNDI3OGMwMDQ1MGNmMzg1ZmY1NThmNTgzMjUyZDlmZWEwZGQ5NWE0MzQ3ZDMifQ==&pageFromUrl="+dfUrl+"&parentPageFromUrl="+dfParentUrl;var s2 = document.getElementsByTagName("script")[0];s2.parentNode.insertBefore(s, s2);})();`,
//       }}
//     />

//     <Script
//       strategy="idle"
//       dangerouslySetInnerHTML={{
//         _html: `!function(e,t){(e=t.createElement("script")).src="https://cdn.convertbox.com/convertbox/js/embed.js",e.id="app-convertbox-script",e.async=true,e.dataset.uuid="a1ce5f9e-d630-4668-be5b-3554f61e94a7",document.getElementsByTagName("head")[0].appendChild(e)}(window,document);`,
//       }}
//     />
//   </>;
// };

// export const onInitialClientRender = () => {
//   // wait to init GTM until after React has hydrated in this lifecycle
//   const dataLayer = window?.dataLayer || [];
//   dataLayer.push({ "gtm.start": new Date().getTime(), event: "gtm.js" });
// };

/**
 * Staging only: turn off Gatsby's link prefetching.
 *
 * Staging sits behind Basic-Auth (see netlify.toml [context.branch-deploy] and
 * _headers-staging). Gatsby prefetches a link's page-data on hover, and those
 * background requests don't carry the Basic-Auth credentials the browser cached
 * for the top-level page — so each hover gets a 401 and Chrome re-opens its
 * "Sign in" dialog.
 *
 * Disabling prefetch on staging removes the prompts. Production is unaffected:
 * GATSBY_IS_STAGING is set only in Netlify's branch-deploy context, so this
 * returns false there and prefetching behaves exactly as before.
 */
export const disableCorePrefetching = () =>
  process.env.GATSBY_IS_STAGING === "true";
